import React, {useCallback, useEffect, useState} from 'react';
import Newsletter from 'assets/images/newsletter.svg';
import CheckSquare from 'assets/images/check-square.svg';
import Shurikens from 'assets/images/shurikens.svg';
import Shurikens2 from 'assets/images/shurikens-2.svg';
import './index.scss';
import GlobalApi from '../../services/Global';
import {storage} from '../../services/config/storage';
import {setActiveModal, updateUserDetails} from '../../store/global/actions';
import {message} from 'antd';
import {MODALS, TIMEOUT} from '../../utils/constants';
import {useDispatch, useSelector} from 'react-redux';
import Modal from '../Modal';

export const NewsLetterModal = React.memo(() => {
    const [loading, setLoading] = useState();
    const dispatch = useDispatch();
    const {user, isSilverUser, isGoldUser, activeModal} = useSelector(
        ({global}) => global,
    );

    const updatePreference = useCallback(async (payload, loadingState) => {
        let res = {};
        try {
            setLoading(loadingState);
            res = await GlobalApi.updateUserProps(payload);
        } catch (e) {
            setLoading(null);
        }
        if (!!res) {
            setLoading(null);
            let updatedUserData = {
                ...user,
                userProps: {
                    ...user?.userProps,
                    [payload?.[0]?.propertyKey]: payload?.[0]?.propertyValue,
                },
            };
            storage.set.userDetails(updatedUserData);
            dispatch(updateUserDetails(updatedUserData));
            dispatch(setActiveModal(null));
            message.success(
                loadingState.acceptLoading
                    ? 'Subscribed to newsletter!'
                    : 'Unsubscribed to newsletter!',
                TIMEOUT,
            );
        }
    }, []);

    useEffect(() => {
        if (!activeModal) {
            if (
                !user.userProps?.vickersNewsletterEDMOptIn &&
                (isSilverUser || isGoldUser)
            ) {
                dispatch(setActiveModal(MODALS.NEWS_LETTER));
            }
        }
    }, [activeModal]);

    return (
        <Modal
            loading={loading}
            visible={activeModal === MODALS.NEWS_LETTER}
            maskClosable={false}
            okText={`Yes, I'm Interested`}
            cancelText={`Not Interested`}
            onCancel={() =>
                updatePreference(
                    [
                        {
                            propertyKey: 'vickersNewsletterEDMOptIn',
                            propertyValue: '0',
                        },
                    ],
                    {
                        cancelLoading: true,
                    },
                )
            }
            onOk={() =>
                updatePreference(
                    [
                        {
                            propertyKey: 'vickersNewsletterEDMOptIn',
                            propertyValue: '1',
                        },
                    ],
                    {
                        acceptLoading: true,
                    },
                )
            }
            title={
                <div
                    className={'font-800'}
                    style={{
                        textAlign: 'center',
                        fontSize: 24,
                        letterSpacing: 0.93,
                        paddingTop: 15,
                        fontFamily: 'SfProDisplayBold',
                    }}
                >
                    Join our newsletter
                </div>
            }
            customTitle={true}
        >
            <div className={'news-letter-modal-content'}>
                <img
                    className={'shurikens'}
                    style={{maxWidth: '70%'}}
                    src={Shurikens}
                />
                <img className={'newsletter-pic'} src={Newsletter} />
                <p className={'heading'}>
                    A 15% return for 35 years will result in more than 100X
                    growth to your portfolio. Make your first investment today!
                </p>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <img
                        style={{height: '100%', paddingRight: '1%'}}
                        src={CheckSquare}
                    />
                    Opt in for DBS Insights Direct newsletter
                </div>
                <img className={'shurikens two'} src={Shurikens2} />
            </div>
        </Modal>
    );
});
